import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import dataService from "service/dataService";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isFormValid) {
      try {
        await dataService.forgotPassword(email);
      } catch (error: any) {
        console.error("Error sending password reset email:", error.message);
        alert(`Failed to send password reset email: ${error.message}`);
      }
    }
  };

  useEffect(() => {
    // Validate email
    setEmailError(email.includes('@') && email.length > 0);
  }, [email]);

  useEffect(() => {
    // Update overall form validity
   setIsFormValid(emailError );
  }, [emailError, isFormValid]);

  return (
    <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
      {/* Sign in section */}
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Forgot Password
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email and click submit!
        </p>
        {/* Email */}
        <InputField
          type="email"
          id="email"
          label="Email"
          extra=""
          placeholder="Enter your email"
          variant="auth"
          value={email}
          onchange={(e) => setEmail(e.target.value)}
          required
        />
       {!emailError && email.length > 0 && <p className="mb-2 ml-3 text-base" style={{ color: 'red' }}>Please enter a valid email.</p>}
        {/* Submit Button */}
        <div>
       </div>   
       <div className="mt-4 flex items-center justify-between">
          <button
            onClick={handleSubmit}
            disabled={!isFormValid}
            className="w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Reset Password
          </button>
         </div> 
       </div>
    </div>
  );
};

export default ForgotPassword;
